import { useState, ReactNode } from "react";

interface LoadingState {
  visible: boolean;
  title: string;
  subtitle: string;
}

interface ErrorState {
  visible: boolean;
  title: string;
  message: ReactNode;
}

interface ExportDialogState {
  loading: LoadingState;
  error: ErrorState;
}

const initialState: ExportDialogState = {
  loading: {
    visible: false,
    title: "",
    subtitle: "",
  },
  error: {
    visible: false,
    title: "",
    message: "",
  },
};

export const useExportDialog = () => {
  const [state, setState] = useState<ExportDialogState>(initialState);

  const showLoading = (title: string, subtitle: string = "") => {
    setState({
      loading: {
        visible: true,
        title,
        subtitle,
      },
      error: {
        visible: false,
        title: "",
        message: "",
      },
    });
  };

  const hideLoading = () => {
    setState((prev) => ({
      ...prev,
      loading: {
        visible: false,
        title: "",
        subtitle: "",
      },
    }));
  };

  const showError = (title: string, message: ReactNode) => {
    setState({
      loading: {
        visible: false,
        title: "",
        subtitle: "",
      },
      error: {
        visible: true,
        title,
        message,
      },
    });
  };

  const hideError = () => {
    setState((prev) => ({
      ...prev,
      error: {
        visible: false,
        title: "",
        message: "",
      },
    }));
  };

  const updateLoadingMessage = (title: string, subtitle: string = "") => {
    setState((prev) => ({
      ...prev,
      loading: {
        ...prev.loading,
        title,
        subtitle,
      },
    }));
  };

  const resetAll = () => {
    setState(initialState);
  };

  return {
    // States
    loading: state.loading,
    error: state.error,

    // Actions
    showLoading,
    hideLoading,
    showError,
    hideError,
    updateLoadingMessage,
    resetAll,
  };
};
